import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEvening = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 256,
	height: 72,
	viewBox: "0 0 256 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_16794_322320)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M256.475 -0.132812H0V71.8672H256.475V-0.132812Z",
				fill: "url(#paint0_radial_16794_322320)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M273.695 33.3975C280.049 16.0624 271.147 -3.1414 253.812 -9.49542C236.477 -15.8494 217.273 -6.94756 210.919 10.3875C204.565 27.7226 213.467 46.9263 230.802 53.2804C248.137 59.6344 267.341 50.7325 273.695 33.3975Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M238.754 10.2968C238.754 13.5168 236.144 16.1268 232.924 16.1268C229.704 16.1268 227.094 13.5168 227.094 10.2968C227.094 7.07681 229.704 4.4668 232.924 4.4668C236.144 4.4668 238.754 7.07681 238.754 10.2968Z",
				fill: "#E7EDF2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M251.229 37.1772C251.229 40.6622 248.404 43.4872 244.919 43.4872C241.434 43.4872 238.609 40.6622 238.609 37.1772C238.609 33.6922 241.434 30.8672 244.919 30.8672C248.404 30.8672 251.229 33.6922 251.229 37.1772Z",
				fill: "#E7EDF2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M258.434 9.57727C258.434 11.6023 256.794 13.2473 254.764 13.2473C252.734 13.2473 251.094 11.6073 251.094 9.57727C251.094 7.54727 252.734 5.90723 254.764 5.90723C256.794 5.90723 258.434 7.54727 258.434 9.57727Z",
				fill: "#E7EDF2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M227.949 35.7374C227.949 37.7624 226.309 39.4073 224.279 39.4073C222.249 39.4073 220.609 37.7674 220.609 35.7374C220.609 33.7074 222.249 32.0674 224.279 32.0674C226.309 32.0674 227.949 33.7124 227.949 35.7374Z",
				fill: "#E7EDF2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M219.635 19.0217C217.71 19.0217 216.135 18.2117 216.135 17.2217C216.135 16.2317 217.71 15.4217 219.635 15.4217H220.315C222.24 15.4217 223.815 14.4767 223.815 13.3217C223.815 12.1667 222.24 11.2217 220.315 11.2217H206.555C204.63 11.2217 203.055 12.1117 203.055 13.2017C203.055 14.2917 201.48 15.1817 199.555 15.1817H198.875C196.95 15.1817 195.375 16.0467 195.375 17.1017C195.375 18.1567 194.7 19.0217 193.875 19.0217C193.05 19.0217 192.375 19.9667 192.375 21.1217C192.375 22.2767 193.95 23.2217 195.875 23.2217H222.355C224.28 23.2217 225.855 22.2767 225.855 21.1217C225.855 19.9667 224.28 19.0217 222.355 19.0217H219.635Z",
				fill: "#2B75A3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M280.124 53.1425C280.124 51.9875 278.549 51.0424 276.624 51.0424H270.304C268.379 51.0424 266.804 50.2874 266.804 49.3624C266.804 48.4374 267.909 47.6824 269.264 47.6824C270.619 47.6824 271.724 46.7375 271.724 45.5825C271.724 44.4275 270.149 43.4824 268.224 43.4824H249.904C247.979 43.4824 246.404 44.4275 246.404 45.5825C246.404 46.7375 247.979 47.6824 249.904 47.6824H254.424C256.349 47.6824 257.924 48.4374 257.924 49.3624C257.924 50.2874 256.349 51.0424 254.424 51.0424H243.784C241.859 51.0424 240.284 51.8774 240.284 52.9024C240.284 53.9274 239.204 54.7625 237.884 54.7625C236.564 54.7625 235.484 55.7074 235.484 56.8624C235.484 58.0174 237.059 58.9624 238.984 58.9624H249.744C251.669 58.9624 253.244 58.1274 253.244 57.1024C253.244 56.0774 254.819 55.2424 256.744 55.2424H276.624C278.549 55.2424 280.124 54.2975 280.124 53.1425Z",
				fill: "#2B75A3"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("radialGradient", {
		id: "paint0_radial_16794_322320",
		cx: 0,
		cy: 0,
		r: 1,
		gradientUnits: "userSpaceOnUse",
		gradientTransform: "translate(229.06 14.0628) scale(66.4727 69.9781)",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#094068" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#07263A"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_16794_322320",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 256,
			height: 72,
			fill: "white"
		})
	})] })]
});
export default SvgEvening;
